import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'

export const indexedPublicationsGToJ: readonly IndexedPublicationsSection[] = [
  {
    letter: 'G',
    references: [
      '@bib{RN2568};',
      '@bib{fromebllab0015}; ',
      '@bib{fromebllab0024};',
      '@bib{Gabbay2023FSMaul};',
      '@bib{HES_5};',
      '@bib{gabbay2014sumerian};',
      '@bib{CT0036};',
      '@bib{CT0038};',
      '@bib{RN2700zza}; ',
      '@bib{RN2700zz};',
      '@bib{CT0041};',
      '@bib{temp_id_4742648949597732};',
      '@bib{UET_6};',
      '@bib{UET_6_2};',
      '@bib{UET_1};',
      '@bib{RN2813xs}; ',
      '@bib{Galter1984Tempel};',
      '@bib{Galter1985Bleitafeln};',
      '@bib{Galter1987Beads};',
      '@bib{GarcíaRecio1999VAT17256a};',
      '@bib{garcíarecio2022de};',
      '@bib{garelli1960nouveau};',
      '@bib{LS242};',
      '@bib{RN1169};',
      '@bib{RN1818};',
      '@bib{RN903};',
      '@bib{MAD_5};',
      '@bib{LS250};',
      '@bib{RN1134a};',
      '@bib{Geller2001Kultmittel};',
      '@bib{Geller2004JMC4};',
      '@bib{RN1711};',
      '@bib{RN967};',
      '@bib{Geller2005Catalogue};',
      '@bib{Geller2006JMC8maladies};',
      '@bib{Geller2006JMC8medecine};',
      '@bib{Geller2009CM37};',
      '@bib{RN1199tz};',
      '@bib{RN2547};',
      '@bib{Geller2023Longevity};',
      '@bib{Geller2020};',
      '@bib{George1985Inscription};',
      '@bib{RN124};',
      '@bib{RN1914};',
      '@bib{RN117}; ',
      '@bib{george2005measurements};',
      '@bib{RN3};',
      '@bib{RN1013a};',
      '@bib{RN1013ab}; ',
      '@bib{george2024old};',
      '@bib{Gerardi1986New};',
      '@bib{gesche2005latebabylonian};',
      '@bib{Glassner2005JMC6};',
      '@bib{santag_9};',
      '@bib{goddeeris2016old};',
      '@bib{Goddeeris2023Some};',
      '@bib{YOS_10};',
      '@bib{temp_id_7776727669690788};',
      '@bib{YOS_15};',
      '@bib{RN262};',
      '@bib{BBDCP};',
      '@bib{RN2799};',
      '@bib{RN258};',
      '@bib{RN904};',
      '@bib{Grayson1983Fragmentary};',
      '@bib{Grayson1983Two};',
      '@bib{RN2832};',
      '@bib{Grayson1985Rivalry};',
      '@bib{Grayson1988Three};',
      '@bib{Grayson1991Fragment};',
      '@bib{Grayson1991Text};',
      '@bib{Green1988Sin-iqisham};',
      '@bib{gregoire1996aaicab1_1};',
      '@bib{gregoire2000aaicab1_2};',
      '@bib{gregoire2001aaicab1_3};',
      '@bib{gregoire2002aaicab1_4};',
      '@bib{YOS_5}; ',
      '@bib{RN250};',
      '@bib{UET_7};',
      '@bib{gurney1974fifth};',
      '@bib{gurney1977inscribed};',
      '@bib{RN728};',
      '@bib{gurney1982three};',
      '@bib{gurney1982gate};',
      '@bib{Gurney1983MBLETU};',
      '@bib{RN697};',
      '@bib{RN2069cc};',
      '@bib{RN2069};',
      '@bib{OECT_5};',
      '@bib{Güterbock1979Some}',
    ],
  },
  {
    letter: 'H',
    references: [
      '@bib{hackl2016additions};',
      '@bib{hackl2014spaetbabylonische};',
      '@bib{Hall1928Egyptian};',
      '@bib{TLB_3};',
      '@bib{Hallo1976Cuneiform};',
      '@bib{Hallo1976Inscribed};',
      '@bib{Hallo1976Stone};',
      '@bib{YOS_22}; ',
      '@bib{UBHD-2021282};',
      '@bib{CT0027};',
      '@bib{RN2700ke4};',
      '@bib{RN2604aaa}; ',
      '@bib{RN2604azz};',
      '@bib{RN2623};',
      '@bib{Harrak1984Inscription};',
      '@bib{fromebllab0002};',
      '@bib{fromebllab0011}; ',
      '@bib{fromebllab0022};',
      '@bib{fromebllab0028};',
      '@bib{KAL17};',
      '@bib{fromebllab0040};',
      '@bib{Haetinen2023FSMaul};',
      '@bib{RN1745xx};',
      '@bib{HauptNimrod};',
      '@bib{RN686};',
      '@bib{RN690};',
      '@bib{RN1156};',
      '@bib{Heessel2009CM37};',
      '@bib{RN2805};',
      '@bib{heesel_zur_2017};',
      '@bib{KAL13};',
      '@bib{Heessel2023FSMaul};',
      '@bib{RN3094a};',
      '@bib{fromebllab0005}; ',
      '@bib{fromebllab0009};',
      '@bib{fromebllab0018};',
      '@bib{Heinrich2023FSMaul};',
      '@bib{fromebllab0038};',
      '@bib{HES_6};',
      '@bib{fromebllab0017};',
      '@bib{hess1999canaan};',
      '@bib{BE_A_1_1};',
      '@bib{BE_A_1_2};',
      '@bib{BE_D_1};',
      '@bib{BE_A_20_1}; ',
      '@bib{RN2817aa};',
      '@bib{BE_A_9};',
      '@bib{BE_D_4};',
      '@bib{Hirsch1985MBLETU};',
      '@bib{RN2700a};',
      '@bib{RN500};',
      '@bib{KAL14}; ',
      '@bib{RN497};',
      '@bib{LS125};',
      '@bib{RN2049};',
      '@bib{LS159};',
      '@bib{LS159as}; ',
      '@bib{LS159asdf};',
      '@bib{hunger2017so-called};',
      '@bib{hunger2022astronomical};',
      '@bib{OECT_8};',
      '@bib{Hurowitz2006JMC8}',
    ],
  },
  {
    letter: 'J',
    references: [
      '@bib{Jacquet2020contrats};',
      '@bib{Jacquet2020nouveaux};',
      '@bib{RN2805zzxx};',
      '@bib{Jakob2023FSMaul};',
      '@bib{KAL16};',
      '@bib{jakobrost1968neubabylonisches}; ',
      '@bib{jakobrost1970urkunden};',
      '@bib{VS_28};',
      '@bib{NAR1};',
      '@bib{jakobrost1972spaetbabylonische};',
      '@bib{VS_20}; ',
      '@bib{VS_21};',
      '@bib{VS_23};',
      '@bib{NAR2};',
      '@bib{RN3647}; ',
      '@bib{RN2699};',
      '@bib{fromebllab0001};',
      '@bib{fromebllab0003};',
      '@bib{fromebllab0008}; ',
      '@bib{fromebllab0010};',
      '@bib{fromebllab0016};',
      '@bib{fromebllab0027}; ',
      '@bib{jimenez2022middle};',
      '@bib{Jimenez2023Prehistory};',
      '@bib{fromebllab0039};',
      '@bib{NABU2024-47};',
      '@bib{fromebllab0032};',
      '@bib{joannes1987fragments};',
      '@bib{OECT_12};',
      '@bib{RN1735};',
      '@bib{jursa1995vermessungen};',
      '@bib{jursa1999archiv};',
      '@bib{jursa2003spaetachaemenidische};',
      '@bib{NABU2007-54};',
      '@bib{jursa2014neoassyrian};',
      '@bib{jursa2014neolate}',
    ],
  },
]
